<template>
    <div>
        <div style="width:10rem;height:2.6666666666666665rem;background:linear-gradient(90deg,rgba(214,177,115,1) 0%,rgba(241,219,174,1) 100%);">
            <div class="flex-center" style="padding-top:0.7466666666666667rem;">

                <img v-if="['NEED_TO_BE_HANDLE','IN_HANDLING'].indexOf(detail.itemStatus)>=0" src="../../image/detail/clock-white.png" style="margin-right:0.21333333333333335rem;width:0.5333333333333333rem;height:0.5333333333333333rem;"></img>
                <img  v-else-if="detail.itemStatus=='COMPLETED'" src="../../image/detail/correct-border_white.png" style="margin-right:0.21333333333333335rem;width:0.5333333333333333rem;height:0.5333333333333333rem;"></img>
                <img v-else-if="detail.itemStatus=='INVALID'" src="../../image/detail/error-border_white.png" style="margin-right:0.21333333333333335rem;width:0.5333333333333333rem;height:0.5333333333333333rem;"></img>

                <div style="height:0.4533333333333333rem;line-height:0.4533333333333333rem;font-size:0.48rem;font-family:PingFang SC;font-weight:bold;color:rgba(255,255,255,1);">{{['待办','办理中','已完成','无效'][['NEED_TO_BE_HANDLE', 'IN_HANDLING', 'COMPLETED', 'INVALID'].indexOf(detail.itemStatus)]}}</div>
            </div>
            <div style="margin-top:0.29333333333333333rem;height:0.32rem;line-height:0.32rem;text-align:center;font-size:0.32rem;font-family:PingFang SC;font-weight:400;color:rgba(255,255,255,1);">{{subtitle}}</div>
        </div>

        <div style="width:10rem;height:11.786666666666667rem;background:rgba(255,255,255,1);">
            <div style="padding:0.52rem 0.41333333333333333rem;height:0.36rem;line-height:0.36rem;font-size:0.37333333333333335rem;font-family:PingFang SC;font-weight:bold;color:rgba(51,51,51,1);">{{["救援信息","保养预约信息","车险报价信息"][["ONE_TOUCH_RESCUE","MAINTAIN_APPOINTMENT","CAR_INSURANCE_QUOTE"].indexOf(detail.itemType)]}}</div>
            <div v-for="(item,index) in detailList">

                <div v-if="item.isMulti==null || item.isMulti==false" class="flex-start" :style="'margin-bottom:'+(item.marginBottom)+';height:0.3333333333333333rem;line-height:0.3333333333333333rem;font-size:0.3466666666666667rem;font-family:PingFang SC;font-weight:400;'">
                    <div style="margin-left:0.4266666666666667rem;width:2.493333333333333rem;color:rgba(153,153,153,1);">{{item.title}}</div>
                    <div class="ellipsis-1" style="width:5.88rem;color:rgba(51,51,51,1);">{{item.content}}</div>
                    <div v-if="item.imgName!=null" style="width:0.8rem;">
                        <a v-if="item.imgName=='phone'" :href="'tel:'+item.content">
                            <img src="../../image/detail/phone-green.png" style="margin-left:0.4rem;margin-right:0.4rem;width:0.4rem;height:0.4rem;"></img>
                        </a>
                        <img v-else-if="item.imgName=='navigate'" src="../../image/detail/nav-red.png" style="margin-left:0.4rem;margin-right:0.4rem;width:0.4rem;height:0.4rem;"></img>

                    </div>
                </div>
                <div v-else class="flex-start" :style="'margin-bottom:'+item.marginBottom+';align-items:flex-start;font-size:0.3466666666666667rem;font-family:PingFang SC;font-weight:400;'">
                    <div style="margin-left:0.4266666666666667rem;height:0.3333333333333333rem;line-height:0.3333333333333333rem;width:2.493333333333333rem;color:rgba(153,153,153,1);">{{item.title}}</div>
                    <div style="line-height:0.4266666666666667rem;width:5.88rem;color:rgba(51,51,51,1);">{{item.content}}</div>
                </div>

            </div>


            <div v-if="detail.itemType=='ONE_TOUCH_RESCUE' && detail.itemStatus=='IN_HANDLING'" style="margin-top:0.8533333333333334rem;">
                <!--<div class="flex-start" style="height:0.3333333333333333rem;line-height:0.3333333333333333rem;">-->
                    <!--<img src="../../image/detail/required-orange.png" style="padding-left:0.14666666666666667rem;padding-right:0.16rem;width:0.10666666666666667rem;height:0.10666666666666667rem;"></img>-->
                    <!--<div style="font-size:0.3466666666666667rem;font-family:PingFang SC;font-weight:400;color:rgba(153,153,153,1);">救援详情描述</div>-->
                <!--</div>-->
                <div style="margin-left:0.4266666666666667rem;height:0.3333333333333333rem;line-height:0.3333333333333333rem;font-size:0.3466666666666667rem;font-family:PingFang SC;font-weight:400;color:rgba(153,153,153,1);">救援详情描述</div>

                <div style="margin-top:0.4rem;margin-left:0.38666666666666666rem;">
                    <textarea :value="oneTouchRescueDetail" @input="oneTouchRescueDetail=$event.target.value" maxlength="-1" placeholder="请填写救援详情描述" placeholder-style="color:rgba(204,204,204,1);" style="padding:0.32rem 0.3333333333333333rem;box-sizing:border-box;width:9.2rem;height:2.8533333333333335rem;background:rgba(250,250,250,1);border:1px solid rgba(233,233,233,1);border-radius:0.13333333333333333rem;font-size:0.32rem;font-family:PingFang SC;font-weight:400;"></textarea>
                </div>
            </div>
        </div>

        <!--占位-->
        <div style="height:1.92rem;"></div>

        <div style="position:fixed;bottom:0rem;z-index:2;width:10rem;background:rgba(255,255,255,1);font-size:0.4rem;font-family:PingFang SC;font-weight:400;line-height:1.07rem;text-align:center;">
            <div v-if="detail.itemStatus=='NEED_TO_BE_HANDLE'" style="width:10rem;height:1.6rem;" class="flex-end">
                <div v-if="detail.itemType=='ONE_TOUCH_RESCUE'" class="flex-end">
                    <div @click="historyBackOrCloseWindow" style="margin-right: 0.25rem;-webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;width:2.99rem;height:1.07rem;background:rgba(255,255,255,1);border:1px solid rgba(230,154,97,1);border-radius:0.53rem;color:rgba(230,154,97,1);">取消</div>
                    <div @click="navigateToRefuseReason" style="margin-right: 0.25rem;-webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;width:2.99rem;height:1.07rem;background:rgba(255,255,255,1);border:1px solid rgba(230,154,97,1);border-radius:0.53rem;color:rgba(230,154,97,1);">拒绝</div>
                    <div @click="statusToConfirm" style="margin-right: 0.27rem;width:2.99rem;height:1.07rem;background:rgba(230,154,97,1);border-radius:0.53rem;color:rgba(255,255,255,1);">接单</div>
                </div>
                <div v-if="detail.itemType=='CAR_INSURANCE_QUOTE'" class="flex-end">
                    <div @click="historyBackOrCloseWindow" style="margin-right: 0.25rem;-webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;width:2.99rem;height:1.07rem;background:rgba(255,255,255,1);border:1px solid rgba(230,154,97,1);border-radius:0.53rem;color:rgba(230,154,97,1);">取消</div>
                    <a :href="'tel:'+detail.phone"><div style="margin-right: 0.25rem;-webkit-box-sizing: border-box;-moz-box-sizing: border-box;box-sizing: border-box;width:2.99rem;height:1.07rem;background:rgba(255,255,255,1);border:1px solid rgba(230,154,97,1);border-radius:0.53rem;color:rgba(230,154,97,1);">联系客户</div></a>
                    <div @click="statusToComplete" style="margin-right: 0.27rem;width:2.99rem;height:1.07rem;background:rgba(230,154,97,1);border-radius:0.53rem;color:rgba(255,255,255,1);">已报价</div>
                </div>
                <div v-if="detail.itemType=='MAINTAIN_APPOINTMENT'" class="flex-end">
                    <div @click="statusToComplete" style="margin-right: 0.27rem;width:2.99rem;height:1.07rem;background:rgba(230,154,97,1);border-radius:0.53rem;color:rgba(255,255,255,1);">确定</div>
                </div>
            </div>
            <div v-else-if="detail.itemType=='ONE_TOUCH_RESCUE' && detail.itemStatus=='IN_HANDLING'" class="flex-end" style="width:10rem;height:1.6rem;">
                <div @click="oneTouchRescueComplete" style="margin-right:0.27rem;width:2.99rem;height:1.07rem;background:rgba(230,154,97,1);border-radius:0.53rem;color:rgba(255,255,255,1);">保存完成</div>
            </div>
        </div>
    </div>

</template>

<script>
    import request from '@/utils/request'
    import {
        Toast
    } from 'vant';

    export default {
        name: "oneTouchRescue",
        components: {
            [Toast.name]: Toast
        },
        data() {
            return {
                detail:null,

                oneTouchRescueDetail:""
            }
        },
        created:function(){

            let id=this.$route.query.id;

            //@error
            // id="8a2edabc-f8ec-40fa-810f-e1e0e9df52c4";

            this.setDetail(id);
        },
        methods: {
            historyBackOrCloseWindow(){
                let close=window.navigator.userAgent.toLowerCase();
                if(close.indexOf('micromessenger')!==-1){
                    WeixinJSBridge.call('closeWindow');
                }
                else{
                    history.back()
                }
            },
            setDetail(id){
                let _this=this;
                Toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    overlay:true
                });
                request({
                    url: '/item/one?id='+id,
                    method: 'GET',
                }).then(res=>{
                    Toast.clear();
                    if(res.code=="200"){
                        let detail=res.data;

                        //@error
                        // detail.itemStatus='NEED_TO_BE_HANDLE';

                        _this.detail=detail;


                        let title=['一键救援','保养预约','车险报价'][["ONE_TOUCH_RESCUE","MAINTAIN_APPOINTMENT","CAR_INSURANCE_QUOTE"].indexOf(detail.itemType)]
                        document.title=title;
                    }else{
                        Toast(res.msg);
                    }
                });
            },
            oneTouchRescueComplete(){
                let _this=this;
                let dataSource=this.detail;
                let id=dataSource.id;
                let oneTouchRescueDetail=this.oneTouchRescueDetail;
                Toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    overlay:true
                });
                request({
                    url: '/item/complete',
                    method: 'PUT',
                    data:{
                        id:id,
                        specificTreatment:oneTouchRescueDetail
                    }
                }).then(res=>{
                    Toast.clear();
                    if(res.code=="200"){
                        _this.setDetail(id);
                    }else{
                        Toast(res.msg);
                    }
                });

            },
            statusToComplete(){
                let _this=this;
                let dataSource=this.detail;
                let id=dataSource.id;
                Toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    overlay:true
                });
                request({
                    url: "/item/complete",
                    method: 'PUT',
                    data:{
                        id:id
                    }
                }).then(res=>{
                    Toast.clear();
                    if(res.code=="200"){
                        _this.setDetail(id);
                    }else{
                        Toast(res.msg);
                    }
                });
            },

            statusToConfirm(){
                // let _this=this;
                // let dataSource=this.detail;
                // let id=dataSource.id;
                // request({
                //     url: "/item/confirm",
                //     method: 'PUT',
                //     data:{
                //         id:id
                //     }
                // }).then(res=>{
                //     if(res.code=="200"){
                //         _this.setDetail(id);
                //     }else{
                //         Toast(res.msg);
                //     }
                // });


                let dataSource=this.detail;
                dataSource.itemStatus='IN_HANDLING'
                this.detail=dataSource;
            },

            navigateToRefuseReason(){
                this.$router.push({
                    name:'BManageNotice/refuseReason',
                    params:{
                        id:this.detail.id,
                        data:[
                            {
                                title:"战败",
                                content:"客户被其他公司抢走"
                            },
                            {
                                title: "无法接通",
                                content: "空号、三次以上拨打无人接听、挂断等情况"
                            },
                            {
                                title: "其他",
                                content: "需要注明具体原因"
                            }
                        ]
                    }
                });
            },

            formatDate:function (time, format) {

                let t = new Date(time);

                if (format.indexOf("yyyy") >= 0) {
                    format = format.replace("yyyy", t.getFullYear())
                }
                else if (format.indexOf("yy") >= 0) {
                    format = format.replace("yy", (t.getFullYear() + "").substring(2));
                }

                let formatMapping = {
                    M: (t.getMonth() + 1),
                    m: t.getMinutes(),
                    d: t.getDate(),
                    h: t.getHours(),
                    s: t.getSeconds()
                }

                let keys = Object.keys(formatMapping);
                for (let i = 0; i < keys.length; i++) {
                    let key = keys[i];
                    if (format.indexOf(key + key) >= 0) {
                        let result = formatMapping[key];
                        format = format.replace(key + key, (result + "").length == 2 ? result : "0" + result);
                    } else if (format.indexOf(key) >= 0) {
                        format = format.replace(key, formatMapping[key]);
                    }
                }

                return format;
            },
            oneTouchRescue(dataSource){
                let status=dataSource.itemStatus;
                let list=[
                    {
                        title:'车牌号',
                        content:dataSource.plateNumber,
                        marginBottom:'0.30666666666666664rem'
                    },
                    {
                        title:'车型品牌',
                        content:dataSource.vehicleBrand,
                        marginBottom:'0.84rem'
                    },
                    {
                        title:'用户电话',
                        content:dataSource.phone,
                        marginBottom:'0.84rem',
                        imgName:'phone',
                    },
                    {
                        title:'预约门店',
                        content:dataSource.shopLiteEntry.shopName,
                        marginBottom:'0.30666666666666664rem'
                    },
                    {
                        title:'救援位置',
                        content:dataSource.rescueAddress,
                        marginBottom:'0.84rem',
                        // imgName:'navigate',
                    },
                    {
                        title:'拨打时间',
                        content:this.formatDate(dataSource.createTime,'yyyy-MM-dd hh:mm:ss'),
                        marginBottom:'0rem'
                    }
                ];

                //状态是 已完成
                if(status=='COMPLETED'){
                    //设置数组最后的一项的marginBottom
                    list[list.length-1].marginBottom='0.30666666666666664rem';
                    list=list.concat([
                        {
                            title:'完成时间',
                            content:this.formatDate(dataSource.completedTime,'yyyy-MM-dd hh:mm:ss'),
                            marginBottom:'0.84rem'
                        },
                        {
                            title:'救援详情描述',
                            content:dataSource.specificTreatment,
                            isMulti:true,
                            marginBottom:'0rem'
                        }
                    ])
                }else if(status=='INVALID'){//状态是 无效
                    //设置数组最后的一项的marginBottom
                    list[list.length-1].marginBottom='0.84rem';
                    list=list.concat([
                        {
                            title:'无效原因',
                            content:dataSource.invalidReason,
                            marginBottom:'0.32rem'
                        },
                        {
                            title:'具体原因',
                            content:dataSource.specificReasons,
                            isMulti:true,
                            marginBottom:'0rem'
                        }
                    ])
                }

                return list;
            },
            maintainAppointment(dataSource){
                let status=dataSource.itemStatus;

                let list=[
                    {
                        title:'车牌号',
                        content:dataSource.plateNumber,
                        marginBottom:'0.84rem'
                    },
                    {
                        title:'用户姓名',
                        content:dataSource.name,
                        marginBottom:'0.30666666666666664rem'
                    },
                    {
                        title:'用户电话',
                        content:dataSource.phone,
                        marginBottom:'0.84rem',
                        imgName:'phone'
                    },
                    {
                        title:'预约门店',
                        content:dataSource.shopLiteEntry.shopName,
                        marginBottom:'0.84rem'
                    },
                    {
                        title:'用户提交时间',
                        content:this.formatDate(dataSource.createTime,'yyyy-MM-dd hh:mm:ss'),
                        marginBottom:'0.30666666666666664rem'
                    }
                ]

                if(status=="COMPLETED"){
                    list.push({
                        title:'完成时间',
                        content:this.formatDate(dataSource.completedTime,'yyyy-MM-dd hh:mm:ss'),
                        marginBottom:'0rem'
                    })
                }
                return list;
            },
            carInsuranceQuote(dataSource){
                let status=dataSource.itemStatus;

                let list=[
                    {
                        title:'车牌号',
                        content:dataSource.plateNumber,
                        marginBottom:'0.30666666666666664rem'
                    },
                    {
                        title:'行驶城市',
                        content:dataSource.drivingCity,
                        marginBottom:'0.30666666666666664rem'
                    },
                    {
                        title:'上牌时间',
                        content:this.formatDate(dataSource.registrationTime,'yyyy-MM-dd'),
                        marginBottom:'0.30666666666666664rem'
                    },
                    {
                        title:'车辆价格',
                        content:dataSource.carPrice+'万',
                        marginBottom:'0.84rem'
                    },
                    {
                        title:'用户姓名',
                        content:dataSource.name,
                        marginBottom:'0.30666666666666664rem'
                    },
                    {
                        title:'用户电话',
                        content:dataSource.phone,
                        marginBottom:'0.84rem',
                        imgName:'phone'
                    },
                    {
                        title:'预约门店',
                        content:dataSource.shopLiteEntry.shopName,
                        marginBottom:'0.84rem'
                    },
                    {
                        title:'用户提交时间',
                        content:this.formatDate(dataSource.createTime,'yyyy-MM-dd hh:mm:ss'),
                        marginBottom:'0.30666666666666664rem'
                    }
                ];

                if(status=="COMPLETED"){
                    list.push({
                        title:'完成时间',
                        content:this.formatDate(dataSource.completedTime,'yyyy-MM-dd hh:mm:ss'),
                        marginBottom:'0rem'
                    })
                }
                return list;

                return list;
            }
        },
        computed: {
            subtitle:function(){
                let dataSource=this.detail;
                let itemType=dataSource.itemType;
                let itemStatus =dataSource.itemStatus ;


                let itemTypeMappingData={
                    "ONE_TOUCH_RESCUE":{
                        textList:['请确认救援信息，尽快进行救援','请尽快赶往现场，并记录','做得非常好，请继续努力','无需气馁，再接再厉'],
                        statusList:['NEED_TO_BE_HANDLE', 'IN_HANDLING', 'COMPLETED', 'INVALID']
                    },
                    "MAINTAIN_APPOINTMENT":{
                        textList:['请根据客户车辆信息，尽快回复报价','做得非常好，请继续努力'],
                        statusList:['NEED_TO_BE_HANDLE','COMPLETED']
                    },
                    "CAR_INSURANCE_QUOTE":{
                        textList:['请根据客户车辆信息，尽快回复报价','做得非常好，请继续努力'],
                        statusList:['NEED_TO_BE_HANDLE','COMPLETED']
                    }
                }

                let currentData=itemTypeMappingData[itemType];

                return currentData.textList[currentData.statusList.indexOf(itemStatus)];
            },
            // 计算属性的 getter
            detailList: function () {
                // `this` 指向 vm 实例
                let dataSource=this.detail;
                let itemType=dataSource.itemType;

                let itemTypeMappingMethod={
                    "ONE_TOUCH_RESCUE":this.oneTouchRescue,
                    "MAINTAIN_APPOINTMENT":this.maintainAppointment,
                    "CAR_INSURANCE_QUOTE":this.carInsuranceQuote,
                }

                let list=itemTypeMappingMethod[itemType](dataSource);



                return list;
            }
        }
    }
</script>

<style scoped>
    .flex-center{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:center;
    }
    .flex-start{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:flex-start;
    }
    .flex-end{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:flex-end;
    }
    .flex-between{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:space-between;
    }
    .flex-around{
        display:flex;
        flex-direction: row;
        align-items:center;
        justify-content:space-around;
    }




    .ellipsis-1{
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .ellipsis-2{
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
    }
    .ellipsis-3{
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
    }
</style>
